Pollster = require './pollster'
moment = require 'moment'
pattern = require 'matchbook'

startsWith = (str, otherStr) ->
  if typeof str != 'string'
    throw Error("Not a string!")
  str.indexOf(otherStr) == 0

normalizeRow = (row) ->
  date: row.date
  statementUrl: row.statementUrl
  fallbackText: row.item
  translationKey: row.translationKey
  translationArgs: row.translationSubstitutions
  amount: Math.abs(row.amount)
  type: if startsWith(row.item, 'Credit.')
      'return'
    else if startsWith(row.item, 'Refund to your')
      'refund'
    else if row.amount > 0
      'credit'
    else if row.amount < 0
      'debit'
    else
      throw new Error("Cannot format a row with 0 amount!")

stateForResponse = (res) ->
  statement = (res.statement ? [])
  .filter (row) -> row.amount != 0
  .map normalizeRow
  .reverse()

  { statement }

module.exports = class BillingPollster extends Pollster
  constructor: ->
    super
    lastValue = null
    @state = @_protectedState.map pattern (match) ->
      match [{ value: pattern.Any }], ({ value }) -> lastValue = stateForResponse(value)
      match [{ error: pattern.Any }], ({ error }) -> errorText: error.message
      match [{ timeout: true }], -> lastValue
      match [{}], -> {}
    return



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/billing-pollster.coffee